import(/* webpackMode: "eager" */ "/vercel/path0/apps/keesy/src/app/[locale]/(login-pages)/layout.tsx");
